import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { LocationTypes } from "./locationTypes";
import { setLocation, getLocation } from "./LocationApi";

const initialState: LocationTypes = {
  setLocationLoader: false,
  getLocationLoader: false,
  latitude: null,
  longitude: null,
  error: "",
  display_name: "",
  addressSelectedtype: "",
  locationGot: "",
  locationVerified: "",
  anonymous_id: null,
  searchText: "",
  profileSection: "",
};
export const setLocationAsync = createAsyncThunk(
  "location/set",
  async (payload: any) => {
    const response = await setLocation(payload);
    return response;
  }
);
export const getLocationAsync = createAsyncThunk(
  "location/getLocation", // Unique action type
  async (id: string | null) => {
    const response = await getLocation(id); // Ensure this API fetches the location
    return response;
  }
);

const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    setUserLocation: (state, action: PayloadAction<LocationTypes>) => {
      return { ...state, ...action.payload };
    },
    setAddressType: (state, action: PayloadAction<string>) => {
      state.addressSelectedtype = action.payload;
    },
    setLocationVerifiedStatus: (state, action: PayloadAction<string>) => {
      state.locationVerified = action.payload;
    },
    setCheckoutAddressId(state, action) {
      state.setCheckoutAddressId = action.payload;
    },
    setSearchText(state, action) {
      state.searchText = action.payload;
    },
    setProfilesection(state, action) {
      state.profileSection = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setLocationAsync.pending, (state) => {
        state.setLocationLoader = true;
      })
      .addCase(setLocationAsync.fulfilled, (state, action: any) => {
        state.anonymous_id = action?.payload?.data?.location?.anonymous_id;
        state.setLocationLoader = false;
      })
      .addCase(setLocationAsync.rejected, (state) => {
        state.setLocationLoader = false;
      })

      .addCase(getLocationAsync.fulfilled, (state, action: any) => {
        state.getLocationLoader = false;
        state.locationGot = action?.payload?.data?.location;
        state.addressSelectedtype =
          action?.payload?.data?.location?.addressSelectedtype;
      })

      .addCase(getLocationAsync.pending, (state) => {
        state.getLocationLoader = true;
      })
      .addCase(getLocationAsync.rejected, (state) => {
        state.getLocationLoader = false;
      });
  },
});

export const {
  setUserLocation,
  setAddressType,
  setLocationVerifiedStatus,
  setCheckoutAddressId,
  setSearchText,
  setProfilesection,
} = locationSlice.actions;
export default locationSlice.reducer;
